import undoable from 'redux-undo';
import { getUniqueKey } from '@gp/utils/common';
import {
  IStakeholdersData,
  IReducerAction,
} from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderEdit/types';
import {
  ADD_TYPE_PROJECT_CORE_STAKEHOLDERS,
  DELETE_TYPE_PROJECT_CORE_STAKEHOLDERS,
  SELECT_TYPE_PROJECT_CORE_STAKEHOLDERS,
  ADD_EMP_PROJECT_CORE_STAKEHOLDERS,
  DELETE_EMP_PROJECT_CORE_STAKEHOLDERS,
  UPDATE_EMP_PROJECT_CORE_STAKEHOLDERS,
} from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderEdit/consts';

function stakeholdersDataReducer(
  state: IStakeholdersData[],
  action: IReducerAction<any>,
) {
  switch (action?.type) {
    case ADD_TYPE_PROJECT_CORE_STAKEHOLDERS: {
      const projectCoreStakeholderIndex = state?.findIndex(
        (item) => item?.stakeholder === 'Project Core Stakeholders',
      );
      if (projectCoreStakeholderIndex === -1) return state;
      const projectCoreStakeholder = state?.[projectCoreStakeholderIndex] || {};
      const { organization } = action?.payload || {};
      const organizationDataIndex =
        projectCoreStakeholder?.organization_list?.findIndex(
          (item) => item?.organization === organization,
        );
      if (organizationDataIndex === -1) return state;
      const organizationData =
        projectCoreStakeholder?.organization_list?.[organizationDataIndex] ||
        {};
      if (organizationData?.owner_list?.length >= 3) return state;

      return [
        ...state?.slice(0, projectCoreStakeholderIndex),
        {
          ...projectCoreStakeholder,
          organization_list: [
            ...projectCoreStakeholder?.organization_list?.slice(
              0,
              organizationDataIndex,
            ),
            {
              ...organizationData,
              owner_list: [
                ...organizationData?.owner_list,
                {
                  key: getUniqueKey(),
                  project_owner: '',
                  list: [],
                },
              ],
            },
            ...projectCoreStakeholder?.organization_list?.slice(
              organizationDataIndex + 1,
            ),
          ],
        },
        ...state?.slice(projectCoreStakeholderIndex + 1),
      ];
    }
    case DELETE_TYPE_PROJECT_CORE_STAKEHOLDERS: {
      const projectCoreStakeholderIndex = state?.findIndex(
        (item) => item?.stakeholder === 'Project Core Stakeholders',
      );
      if (projectCoreStakeholderIndex === -1) return state;
      const projectCoreStakeholder = state?.[projectCoreStakeholderIndex] || {};
      const { organization, index } = action?.payload || {};
      const organizationDataIndex =
        projectCoreStakeholder?.organization_list?.findIndex(
          (item) => item?.organization === organization,
        );
      if (organizationDataIndex === -1) return state;
      const organizationData =
        projectCoreStakeholder?.organization_list?.[organizationDataIndex] ||
        {};
      if (organizationData?.owner_list?.length <= 1) return state;
      if (index < 0 || index > organizationData?.owner_list?.length - 1)
        return state;

      return [
        ...state?.slice(0, projectCoreStakeholderIndex),
        {
          ...projectCoreStakeholder,
          organization_list: [
            ...projectCoreStakeholder?.organization_list?.slice(
              0,
              organizationDataIndex,
            ),
            {
              ...organizationData,
              owner_list: [
                ...organizationData?.owner_list?.slice(0, index),
                ...organizationData?.owner_list?.slice(index + 1),
              ],
            },
            ...projectCoreStakeholder?.organization_list?.slice(
              organizationDataIndex + 1,
            ),
          ],
        },
        ...state?.slice(projectCoreStakeholderIndex + 1),
      ];
    }
    case SELECT_TYPE_PROJECT_CORE_STAKEHOLDERS: {
      const projectCoreStakeholderIndex = state?.findIndex(
        (item) => item?.stakeholder === 'Project Core Stakeholders',
      );
      if (projectCoreStakeholderIndex === -1) return state;
      const projectCoreStakeholder = state?.[projectCoreStakeholderIndex] || {};
      const { organization, index, type } = action?.payload || {};
      const organizationDataIndex =
        projectCoreStakeholder?.organization_list?.findIndex(
          (item) => item?.organization === organization,
        );
      if (organizationDataIndex === -1) return state;
      const organizationData =
        projectCoreStakeholder?.organization_list?.[organizationDataIndex] ||
        {};
      if (organizationData?.owner_list?.length < 1) return state;
      if (index < 0 || index > organizationData?.owner_list?.length - 1)
        return state;

      const owner = organizationData?.owner_list?.[index] || {};
      const emps = owner?.list || [];
      const emp =
        organization === 'studio'
          ? {
              id: '',
              name: '',
              user_id: '',
              position: '',
              link: '',
              options: [],
            }
          : {
              id: '',
              name: '',
              user_id: '',
              position: '',
              options: [],
            };

      return [
        ...state?.slice(0, projectCoreStakeholderIndex),
        {
          ...projectCoreStakeholder,
          organization_list: [
            ...projectCoreStakeholder?.organization_list?.slice(
              0,
              organizationDataIndex,
            ),
            {
              ...organizationData,
              owner_list: [
                ...organizationData?.owner_list?.slice(0, index),
                {
                  ...owner,
                  project_owner: type || '',
                  // list: !type ? [] : emps?.length > 0 ? emps : [emp],
                  list: emps?.length > 0 ? emps : [emp],
                },
                ...organizationData?.owner_list?.slice(index + 1),
              ],
            },
            ...projectCoreStakeholder?.organization_list?.slice(
              organizationDataIndex + 1,
            ),
          ],
        },
        ...state?.slice(projectCoreStakeholderIndex + 1),
      ];
    }
    case ADD_EMP_PROJECT_CORE_STAKEHOLDERS: {
      const projectCoreStakeholderIndex = state?.findIndex(
        (item) => item?.stakeholder === 'Project Core Stakeholders',
      );
      if (projectCoreStakeholderIndex === -1) return state;
      const projectCoreStakeholder = state?.[projectCoreStakeholderIndex] || {};
      const { organization, index } = action?.payload || {};
      const organizationDataIndex =
        projectCoreStakeholder?.organization_list?.findIndex(
          (item) => item?.organization === organization,
        );
      if (organizationDataIndex === -1) return state;
      const organizationData =
        projectCoreStakeholder?.organization_list?.[organizationDataIndex] ||
        {};
      if (organizationData?.owner_list?.length < 1) return state;
      if (index < 0 || index > organizationData?.owner_list?.length - 1)
        return state;

      const owner = organizationData?.owner_list?.[index] || {};
      const emps = owner?.list || [];
      const emp =
        organization === 'studio'
          ? {
              id: '',
              name: '',
              user_id: '',
              position: '',
              link: '',
              options: [],
            }
          : {
              id: '',
              name: '',
              user_id: '',
              position: '',
              options: [],
            };

      return [
        ...state?.slice(0, projectCoreStakeholderIndex),
        {
          ...projectCoreStakeholder,
          organization_list: [
            ...projectCoreStakeholder?.organization_list?.slice(
              0,
              organizationDataIndex,
            ),
            {
              ...organizationData,
              owner_list: [
                ...organizationData?.owner_list?.slice(0, index),
                {
                  ...owner,
                  list: [...emps, emp],
                },
                ...organizationData?.owner_list?.slice(index + 1),
              ],
            },
            ...projectCoreStakeholder?.organization_list?.slice(
              organizationDataIndex + 1,
            ),
          ],
        },
        ...state?.slice(projectCoreStakeholderIndex + 1),
      ];
    }
    case DELETE_EMP_PROJECT_CORE_STAKEHOLDERS: {
      const projectCoreStakeholderIndex = state?.findIndex(
        (item) => item?.stakeholder === 'Project Core Stakeholders',
      );
      if (projectCoreStakeholderIndex === -1) return state;
      const projectCoreStakeholder = state?.[projectCoreStakeholderIndex] || {};
      const { organization, index, empIndex } = action?.payload || {};
      const organizationDataIndex =
        projectCoreStakeholder?.organization_list?.findIndex(
          (item) => item?.organization === organization,
        );
      if (organizationDataIndex === -1) return state;
      const organizationData =
        projectCoreStakeholder?.organization_list?.[organizationDataIndex] ||
        {};
      if (organizationData?.owner_list?.length < 1) return state;
      if (index < 0 || index > organizationData?.owner_list?.length - 1)
        return state;

      const owner = organizationData?.owner_list?.[index] || {};
      const emps = owner?.list || [];
      if (emps?.length <= 1) return state;
      if (empIndex < 0 || empIndex > emps?.length - 1) return state;

      return [
        ...state?.slice(0, projectCoreStakeholderIndex),
        {
          ...projectCoreStakeholder,
          organization_list: [
            ...projectCoreStakeholder?.organization_list?.slice(
              0,
              organizationDataIndex,
            ),
            {
              ...organizationData,
              owner_list: [
                ...organizationData?.owner_list?.slice(0, index),
                {
                  ...owner,
                  list: [
                    ...emps?.slice(0, empIndex),
                    ...emps?.slice(empIndex + 1),
                  ],
                },
                ...organizationData?.owner_list?.slice(index + 1),
              ],
            },
            ...projectCoreStakeholder?.organization_list?.slice(
              organizationDataIndex + 1,
            ),
          ],
        },
        ...state?.slice(projectCoreStakeholderIndex + 1),
      ];
    }
    case UPDATE_EMP_PROJECT_CORE_STAKEHOLDERS: {
      const projectCoreStakeholderIndex = state?.findIndex(
        (item) => item?.stakeholder === 'Project Core Stakeholders',
      );
      if (projectCoreStakeholderIndex === -1) return state;
      const projectCoreStakeholder = state?.[projectCoreStakeholderIndex] || {};
      const { organization, index, empIndex, emp: newEmp, } = action?.payload || {};
      const organizationDataIndex =
        projectCoreStakeholder?.organization_list?.findIndex(
          (item) => item?.organization === organization,
        );
      if (organizationDataIndex === -1) return state;
      const organizationData =
        projectCoreStakeholder?.organization_list?.[organizationDataIndex] ||
        {};
      if (organizationData?.owner_list?.length < 1) return state;
      if (index < 0 || index > organizationData?.owner_list?.length - 1)
        return state;

      const owner = organizationData?.owner_list?.[index] || {};
      const emps = owner?.list || [];
      if (emps?.length < 1) return state;
      if (empIndex < 0 || empIndex > emps?.length - 1) return state;
      const emp = emps?.[empIndex] || {};

      return [
        ...state?.slice(0, projectCoreStakeholderIndex),
        {
          ...projectCoreStakeholder,
          organization_list: [
            ...projectCoreStakeholder?.organization_list?.slice(
              0,
              organizationDataIndex,
            ),
            {
              ...organizationData,
              owner_list: [
                ...organizationData?.owner_list?.slice(0, index),
                {
                  ...owner,
                  list: [
                    ...emps?.slice(0, empIndex),
                    {
                      ...emp,
                      ...newEmp,
                    },
                    ...emps?.slice(empIndex + 1),
                  ],
                },
                ...organizationData?.owner_list?.slice(index + 1),
              ],
            },
            ...projectCoreStakeholder?.organization_list?.slice(
              organizationDataIndex + 1,
            ),
          ],
        },
        ...state?.slice(projectCoreStakeholderIndex + 1),
      ];
    }
    default:
      return state;
  }
}

// @ts-ignore
export default undoable(stakeholdersDataReducer, { limit: 3 });
